import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const HEALTH_CONFIG = {
  Excellent: { label: 'Excellent', color: 'success' },
  Healthy: { label: 'Healthy', color: 'info' },
  'Needs Attention': { label: 'Needs Attention', color: 'warning' },
  'High Risk': { label: 'High Risk', color: 'error' },
};

const HealthIndicator = ({ status }) => {
  const config = HEALTH_CONFIG[status] || HEALTH_CONFIG.Healthy;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: `${config.color}.main`, flexShrink: 0 }} />
      <Typography variant="body2" color={`${config.color}.dark`} fontWeight={600}>
        {config.label}
      </Typography>
    </Stack>
  );
};

export default HealthIndicator;